import { useState } from "react";

const SectionsTable = ({
  darkMode,
  sections,
  courseDetails,
  isAttainmentCalculated,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  if (sections.length === 0) {
    return (
      <div
        className="rounded-lg p-4 mb-4 border"
        style={{
          backgroundColor: darkMode ? "#0D1117" : "#F8FAFC",
          borderColor: darkMode ? "#22232B" : "#E5E7EB",
          boxShadow: darkMode ? "none" : "0 1px 2px rgba(0, 0, 0, 0.05)",
        }}
      >
        <div className="flex flex-col items-center justify-center py-2">
          <svg
            className="w-10 h-10 mb-2"
            style={{ color: darkMode ? "#4B5563" : "#9CA3AF" }}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            ></path>
          </svg>
          <p
            className="text-sm font-semibold"
            style={{ color: darkMode ? "#9CA3AF" : "#6B7280" }}
          >
            No sections available for this course.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="rounded-lg p-4 mb-4 border"
      style={{
        backgroundColor: darkMode ? "#0D1117" : "#F8FAFC",
        borderColor: darkMode ? "#22232B" : "#E5E7EB",
        boxShadow: darkMode ? "none" : "0 1px 2px rgba(0, 0, 0, 0.05)",
      }}
    >
      {/* Enhanced Header with Toggle Button */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center">
          <div
            className="w-1 h-5 rounded-full mr-2"
            style={{ backgroundColor: darkMode ? "#10B981" : "#059669" }}
          ></div>
          <h4
            className="text-base font-bold"
            style={{ color: darkMode ? "#FFFFFF" : "#111827" }}
          >
            Faculty Sections
          </h4>
          <span
            className="text-xs font-semibold px-2 py-0.5 rounded-full ml-2"
            style={{
              color: darkMode ? "#6EE7B7" : "#065F46",
              backgroundColor: darkMode ? "rgba(16, 185, 129, 0.2)" : "#D1FAE5",
            }}
          >
            {sections.length} {sections.length === 1 ? "section" : "sections"}
          </span>
        </div>

        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex items-center text-sm font-medium px-2 py-1 rounded"
          style={{
            color: darkMode ? "#9CA3AF" : "#6B7280",
            backgroundColor: darkMode
              ? "rgba(156, 163, 175, 0.1)"
              : "rgba(107, 114, 128, 0.1)",
          }}
        >
          {isExpanded ? (
            <>
              <span className="mr-1">Collapse</span>
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 15l7-7 7 7"
                />
              </svg>
            </>
          ) : (
            <>
              <span className="mr-1">Expand</span>
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </>
          )}
        </button>
      </div>

      {isExpanded && (
        <div
          className="overflow-x-auto rounded-lg border"
          style={{
            borderColor: darkMode ? "#22232B" : "#E5E7EB",
          }}
        >
          <table className="min-w-full">
            <thead>
              <tr
                style={{
                  backgroundColor: darkMode ? "#161B22" : "#FFFFFF",
                }}
              >
                <th
                  className="p-2 text-left text-xs font-bold"
                  style={{
                    color: darkMode ? "#C9CCD1" : "#374151",
                    borderBottom: darkMode
                      ? "1px solid #22232B"
                      : "1px solid #E5E7EB",
                  }}
                >
                  Section
                </th>
                <th
                  className="p-2 text-left text-xs font-bold"
                  style={{
                    color: darkMode ? "#C9CCD1" : "#374151",
                    borderBottom: darkMode
                      ? "1px solid #22232B"
                      : "1px solid #E5E7EB",
                  }}
                >
                  Faculty
                </th>
                <th
                  className="p-2 text-left text-xs font-bold"
                  style={{
                    color: darkMode ? "#C9CCD1" : "#374151",
                    borderBottom: darkMode
                      ? "1px solid #22232B"
                      : "1px solid #E5E7EB",
                  }}
                >
                  Semester Type
                </th>
                <th
                  className="p-2 text-left text-xs font-bold"
                  style={{
                    color: darkMode ? "#C9CCD1" : "#374151",
                    borderBottom: darkMode
                      ? "1px solid #22232B"
                      : "1px solid #E5E7EB",
                  }}
                >
                  Attainment
                </th>
              </tr>
            </thead>
            <tbody>
              {sections.map((section, sectionIndex) =>
                section.faculty_assignments.map((assignment, index) => (
                  <tr
                    key={`${section.section_id}-${assignment.assignment_id}`}
                    className="transition-colors duration-150"
                    style={{
                      backgroundColor: darkMode
                        ? sectionIndex % 2 === 0
                          ? "rgba(26, 31, 46, 0.5)"
                          : "rgba(26, 31, 46, 0.3)"
                        : sectionIndex % 2 === 0
                          ? "#FFFFFF"
                          : "#F9FAFB",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = darkMode
                        ? "rgba(37, 99, 235, 0.15)"
                        : "#EFF6FF";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = darkMode
                        ? sectionIndex % 2 === 0
                          ? "rgba(26, 31, 46, 0.5)"
                          : "rgba(26, 31, 46, 0.3)"
                        : sectionIndex % 2 === 0
                          ? "#FFFFFF"
                          : "#F9FAFB";
                    }}
                  >
                    {index === 0 && (
                      <td
                        className="p-2 border-b font-semibold"
                        style={{
                          color: darkMode ? "#FFFFFF" : "#111827",
                          borderBottomColor: darkMode ? "#22232B" : "#F3F4F6",
                        }}
                        rowSpan={section.faculty_assignments.length}
                      >
                        <span
                          className="px-2 py-1 rounded text-xs font-bold"
                          style={{
                            backgroundColor: darkMode
                              ? "rgba(59, 130, 246, 0.2)"
                              : "#EFF6FF",
                            color: darkMode ? "#93C5FD" : "#1D4ED8",
                          }}
                        >
                          {section.section_name}
                        </span>
                      </td>
                    )}
                    <td
                      className="p-2 border-b text-sm"
                      style={{
                        color: darkMode ? "#EAEAEA" : "#374151",
                        borderBottomColor: darkMode ? "#22232B" : "#F3F4F6",
                        fontWeight: "600",
                      }}
                    >
                      {assignment.faculty_name || (
                        <span
                          className="text-md"
                          style={{
                            color: darkMode ? "#9CA3AF" : "#6B7280",
                            fontStyle: "italic",
                            fontWeight: "500",
                          }}
                        >
                          Not assigned
                        </span>
                      )}
                    </td>
                    <td
                      className="p-2 border-b"
                      style={{
                        color: darkMode ? "#EAEAEA" : "#374151",
                        borderBottomColor: darkMode ? "#22232B" : "#F3F4F6",
                      }}
                    >
                      <span
                        className="px-2 py-1 rounded text-xs font-semibold"
                        style={{
                          backgroundColor: darkMode
                            ? assignment.semester_type === "odd"
                              ? "rgba(249, 115, 22, 0.2)"
                              : "rgba(139, 92, 246, 0.2)"
                            : assignment.semester_type === "odd"
                              ? "#FFEDD5"
                              : "#EDE9FE",
                          color: darkMode
                            ? assignment.semester_type === "odd"
                              ? "#FDBA74"
                              : "#C4B5FD"
                            : assignment.semester_type === "odd"
                              ? "#9A3412"
                              : "#5B21B6",
                        }}
                      >
                        {assignment.semester_type
                          ? assignment.semester_type === "odd"
                            ? "Odd Semester"
                            : "Even Semester"
                          : "N/A"}
                      </span>
                    </td>
                    <td
                      className="p-2 border-b"
                      style={{
                        color: darkMode ? "#EAEAEA" : "#374151",
                        borderBottomColor: darkMode ? "#22232B" : "#F3F4F6",
                      }}
                    >
                      <span
                        className="px-2 py-1 rounded text-xs font-semibold"
                        style={{
                          backgroundColor: section.isAttainmentCalculated
                            ? darkMode
                              ? "rgba(16, 185, 129, 0.2)"
                              : "#D1FAE5"
                            : darkMode
                              ? "rgba(248, 113, 113, 0.2)"
                              : "#FEE2E2",
                          color: section.isAttainmentCalculated
                            ? darkMode
                              ? "#6EE7B7"
                              : "#065F46"
                            : darkMode
                              ? "#F87171"
                              : "#B91C1C",
                        }}
                      >
                        {section.isAttainmentCalculated
                          ? "Calculated"
                          : "Not Calculated"}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SectionsTable;
